import { WithTranslation } from 'react-i18next';

export enum UserRoles {
  EXPERIENCE_MEMBER = 'EXPERIENCE_MEMBER',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  FACILITATOR = 'FACILITATOR',
}

export interface IMultiRoleModalView extends WithTranslation {
  onClick: (isTrainer?: boolean) => void;
}
